// --- External Libraries
import moment from 'moment';
// --- Components
import { CustomHeader } from 'datastage/components/AGGrid/cell-renderers/custom-header';

export const id = {
    field: 'id',
    headerName: 'ID',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'id',
        page: 'pmxDeliveries',
    },
    minWidth: 75,
};

export const action = {
    field: 'action',
    headerName: 'Action',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'action',
        page: 'pmxDeliveries',
    },
    minWidth: 100,
};

export const status = {
    field: 'status',
    headerName: 'Status',
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'status',
        page: 'pmxDeliveries',
    },
    minWidth: 100,
};

export const pmxSkuId = {
    field: 'pmxSku.pmxSkuId',
    headerName: 'SKU ID',
    minWidth: 100,
};

export const productId = {
    field: 'pmxSku.pmxProduct.pmxProductId',
    headerName: 'Product ID',
    minWidth: 100,
};

export const releaseId = {
    field: 'pmxSku.pmxProduct.pmxRelease.pmxReleaseId',
    headerName: 'Release ID',
    minWidth: 100,
};

export const name = {
    field: 'pmxSku.pmxProduct.pmxRelease.releaseName',
    headerName: 'Name',
    minWidth: 100,
};

export const type = {
    field: 'pmxSku.pmxProduct.pmxRelease.releaseType',
    headerName: 'Type',
    minWidth: 100,
};

export const territory = {
    field: 'pmxSku.skuKeyDates[0].territory',
    headerName: 'Territory',
    minWidth: 100,
};

export const releaseDate = {
    field: 'pmxSku.releaseDate',
    headerName: 'Release Date',
    valueFormatter: ({ value }) => (value ? moment(value).format('M/D/YYYY') : ''),
    minWidth: 100,
};

export const error = {
    field: 'errorMsg',
    headerName: 'Error',
    minWidth: 300,
    wrapText: true,
    autoHeight: true,
    cellStyle: { 
        paddingTop: '10px', 
        paddingBottom: '10px',
        wordBreak: 'normal',
        overflowWrap: 'break-word',
    },
};

export const created = {
    field: 'createdAt',
    headerName: 'Created',
    valueFormatter: ({ value }) => (value ? moment(value).format('M/D/YYYY, hh:mm:ss A') : ''),
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'createdAt',
        page: 'pmxDeliveries',
    },
    minWidth: 200,
};

export const modified = {
    field: 'modifiedAt',
    headerName: 'Modified',
    valueFormatter: ({ value }) => (value ? moment(value).format('M/D/YYYY, hh:mm:ss A') : ''),
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'modifiedAt',
        page: 'pmxDeliveries',
    },
    minWidth: 200,
};

